import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("migrations.title"))),
      ]),
      _c(
        VCard,
        { staticClass: "mt-4" },
        [
          _c(
            VTabs,
            {
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(VTab, { key: "email" }, [
                _vm._v(_vm._s(_vm.$t("migrations.email_migration"))),
              ]),
            ],
            1
          ),
          _c(
            VTabsItems,
            {
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                VTabItem,
                { key: "email" },
                [
                  _c(
                    VCardText,
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                VBtn,
                                {
                                  staticClass: "btn-inca-secondary",
                                  attrs: { dense: "", outlined: "" },
                                  on: { click: _vm.addRow },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("icon-add"),
                                  ]),
                                  _vm._v(_vm._s(_vm.$t("migrations.add_row"))),
                                ],
                                1
                              ),
                              _c(
                                VBtn,
                                {
                                  staticClass: "btn-inca-secondary ml-2",
                                  attrs: { dense: "", outlined: "" },
                                  on: { click: _vm.triggerFileInput },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("icon-upload"),
                                  ]),
                                  _vm._v(_vm._s(_vm.$t("migrations.load_csv"))),
                                ],
                                1
                              ),
                              _c(
                                VBtn,
                                {
                                  staticClass: "btn-inca-primary ml-2",
                                  attrs: {
                                    dense: "",
                                    color: "primary",
                                    disabled:
                                      _vm.migrations.length === 0 ||
                                      _vm.loading ||
                                      _vm.selectedEndpoints.length === 0,
                                  },
                                  on: { click: _vm.executeMigration },
                                },
                                [
                                  !_vm.loading
                                    ? _c(VIcon, { attrs: { small: "" } }, [
                                        _vm._v("mdi-play"),
                                      ])
                                    : _vm._e(),
                                  _vm.loading
                                    ? _c(VProgressCircular, {
                                        attrs: {
                                          indeterminate: "",
                                          size: "16",
                                          color: "white",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(_vm._s(_vm.$t("migrations.execute"))),
                                ],
                                1
                              ),
                              _c("input", {
                                ref: "fileInput",
                                staticStyle: { display: "none" },
                                attrs: { type: "file", accept: ".csv" },
                                on: { change: _vm.handleFileUpload },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        { staticClass: "mt-4" },
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(VDataTable, {
                                staticClass: "table-inca",
                                attrs: {
                                  headers: _vm.headers,
                                  items: _vm.migrations,
                                  "hide-default-footer": true,
                                  "disable-pagination": "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.correo_antiguo",
                                    fn: function (ref) {
                                      var item = ref.item
                                      var index = ref.index
                                      return [
                                        _c(VTextField, {
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            placeholder: _vm.$t(
                                              "migrations.old_email_placeholder"
                                            ),
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.validateRow(index)
                                            },
                                          },
                                          model: {
                                            value: item.correo_antiguo,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "correo_antiguo",
                                                $$v
                                              )
                                            },
                                            expression: "item.correo_antiguo",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.correo_nuevo",
                                    fn: function (ref) {
                                      var item = ref.item
                                      var index = ref.index
                                      return [
                                        _c(VTextField, {
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            placeholder: _vm.$t(
                                              "migrations.new_email_placeholder"
                                            ),
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.validateRow(index)
                                            },
                                          },
                                          model: {
                                            value: item.correo_nuevo,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "correo_nuevo",
                                                $$v
                                              )
                                            },
                                            expression: "item.correo_nuevo",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.valid",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        item.valid
                                          ? _c(
                                              VIcon,
                                              { attrs: { color: "success" } },
                                              [_vm._v("mdi-check-circle")]
                                            )
                                          : item.valid === false
                                          ? _c(
                                              VIcon,
                                              { attrs: { color: "error" } },
                                              [_vm._v("mdi-alert-circle")]
                                            )
                                          : _c(
                                              VIcon,
                                              { attrs: { color: "grey" } },
                                              [_vm._v("mdi-circle-outline")]
                                            ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.actions",
                                    fn: function (ref) {
                                      var item = ref.item
                                      var index = ref.index
                                      return [
                                        _c(
                                          VBtn,
                                          {
                                            staticClass: "btn-icon-inca",
                                            attrs: { icon: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeRow(index)
                                              },
                                            },
                                          },
                                          [
                                            _c(VIcon, [
                                              _vm._v("icon-delete"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.migrations.length > 0
                        ? _c(
                            VRow,
                            { staticClass: "mt-4" },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    VCard,
                                    {
                                      staticClass: "endpoint-selection-card",
                                      attrs: { outlined: "" },
                                    },
                                    [
                                      _c(
                                        VCardText,
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex align-center mb-2",
                                            },
                                            [
                                              _c(
                                                VIcon,
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: { small: "" },
                                                },
                                                [_vm._v("mdi-api")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "subtitle-1 font-weight-bold",
                                                },
                                                [_vm._v("Endpoints a ejecutar")]
                                              ),
                                              _c(VSpacer),
                                              _c(
                                                VBtn,
                                                {
                                                  attrs: {
                                                    "x-small": "",
                                                    text: "",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.toggleAllEndpoints,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.allEndpointsSelected
                                                        ? "Desmarcar todos"
                                                        : "Marcar todos"
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            VRow,
                                            _vm._l(
                                              _vm.availableEndpoints,
                                              function (ep, idx) {
                                                return _c(
                                                  VCol,
                                                  {
                                                    key: idx,
                                                    attrs: {
                                                      cols: "6",
                                                      md: "6",
                                                    },
                                                  },
                                                  [
                                                    _c(VCheckbox, {
                                                      staticClass:
                                                        "mt-0 endpoint-checkbox",
                                                      attrs: {
                                                        label: ep.name,
                                                        "hide-details": "",
                                                        dense: "",
                                                      },
                                                      model: {
                                                        value: ep.enabled,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            ep,
                                                            "enabled",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "ep.enabled",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.results
                        ? _c(
                            VRow,
                            { staticClass: "mt-4" },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    VCard,
                                    { staticClass: "results-card" },
                                    [
                                      _c(VCardTitle, [
                                        _vm._v(
                                          _vm._s(_vm.$t("migrations.results"))
                                        ),
                                      ]),
                                      _c(
                                        VCardText,
                                        [
                                          _c(
                                            VRow,
                                            [
                                              _c(
                                                VCol,
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-center",
                                                    },
                                                    [
                                                      _c(
                                                        VIcon,
                                                        {
                                                          attrs: {
                                                            color: "success",
                                                            large: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-check-circle"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "ml-2 success--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "migrations.successful"
                                                              )
                                                            ) +
                                                              ": " +
                                                              _vm._s(
                                                                _vm.results
                                                                  .successful ||
                                                                  0
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                VCol,
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-center",
                                                    },
                                                    [
                                                      _c(
                                                        VIcon,
                                                        {
                                                          attrs: {
                                                            color: "error",
                                                            large: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-alert-circle"
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "ml-2 error--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "migrations.failed"
                                                              )
                                                            ) +
                                                              ": " +
                                                              _vm._s(
                                                                _vm.results
                                                                  .failed || 0
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(VDivider, {
                                            staticClass: "my-3",
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "subtitle-2 mb-2" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "migrations.endpoint_summary"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(VDataTable, {
                                            staticClass: "table-inca",
                                            attrs: {
                                              headers: _vm.endpointHeaders,
                                              items:
                                                _vm.results.endpointSummary,
                                              "hide-default-footer": true,
                                              "disable-pagination": "",
                                              dense: "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "item.status",
                                                  fn: function (ref) {
                                                    var item = ref.item
                                                    return [
                                                      _c(
                                                        VChip,
                                                        {
                                                          attrs: {
                                                            color:
                                                              item.status ===
                                                              "success"
                                                                ? "success"
                                                                : item.status ===
                                                                  "pending"
                                                                ? "grey"
                                                                : "error",
                                                            small: "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "migrations." +
                                                                  item.status
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item.error",
                                                  fn: function (ref) {
                                                    var item = ref.item
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "error--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.error || "-"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item.raw",
                                                  fn: function (ref) {
                                                    var item = ref.item
                                                    return [
                                                      _c(
                                                        VBtn,
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                            text: "",
                                                            color: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.toggleRawResponse(
                                                                item.name
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            VIcon,
                                                            {
                                                              staticClass:
                                                                "mr-1",
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.expandedEndpoint ===
                                                                    item.name
                                                                    ? "mdi-chevron-up"
                                                                    : "mdi-code-json"
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.expandedEndpoint ===
                                                                item.name
                                                                ? "Ocultar"
                                                                : "Ver JSON"
                                                            )
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              646878913
                                            ),
                                          }),
                                          _c(VExpandTransition, [
                                            _vm.expandedEndpoint &&
                                            _vm.rawResponses[
                                              _vm.expandedEndpoint
                                            ]
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      VCard,
                                                      {
                                                        staticClass:
                                                          "raw-json-card mt-3",
                                                        attrs: { flat: "" },
                                                      },
                                                      [
                                                        _c(
                                                          VCardTitle,
                                                          {
                                                            staticClass: "py-2",
                                                          },
                                                          [
                                                            _c(
                                                              VIcon,
                                                              {
                                                                staticClass:
                                                                  "mr-2",
                                                                attrs: {
                                                                  small: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-code-json"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "subtitle-2",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Respuesta raw: " +
                                                                    _vm._s(
                                                                      _vm.expandedEndpoint
                                                                    )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(VSpacer),
                                                            _c(
                                                              VBtn,
                                                              {
                                                                attrs: {
                                                                  icon: "",
                                                                  "x-small": "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    _vm.copyRawResponse,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  VIcon,
                                                                  {
                                                                    attrs: {
                                                                      small: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-content-copy"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          VCardText,
                                                          {
                                                            staticClass: "pa-0",
                                                          },
                                                          [
                                                            _c(
                                                              "pre",
                                                              {
                                                                staticClass:
                                                                  "raw-json-viewer",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.formatJSON(
                                                                      _vm
                                                                        .rawResponses[
                                                                        _vm
                                                                          .expandedEndpoint
                                                                      ]
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]),
                                          _c(VExpandTransition, [
                                            _vm.results.details &&
                                            _vm.results.details.length > 0
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c(VDivider, {
                                                      staticClass: "my-3",
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "subtitle-2 mb-2",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "migrations.row_detail"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(VDataTable, {
                                                      staticClass: "table-inca",
                                                      attrs: {
                                                        headers:
                                                          _vm.resultHeaders,
                                                        items:
                                                          _vm.results.details,
                                                        "hide-default-footer": true,
                                                        "disable-pagination":
                                                          "",
                                                        dense: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "item.status",
                                                            fn: function (ref) {
                                                              var item =
                                                                ref.item
                                                              return [
                                                                _c(
                                                                  VChip,
                                                                  {
                                                                    attrs: {
                                                                      color:
                                                                        item.status ===
                                                                        "success"
                                                                          ? "success"
                                                                          : "error",
                                                                      small: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.status ===
                                                                          "success"
                                                                          ? _vm.$t(
                                                                              "migrations.success"
                                                                            )
                                                                          : _vm.$t(
                                                                              "migrations.error"
                                                                            )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                          {
                                                            key: "item.message",
                                                            fn: function (ref) {
                                                              var item =
                                                                ref.item
                                                              return [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.message ||
                                                                        "-"
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        653415158
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("dialog-confirmation-component", {
        ref: "dialogConfirmation",
        attrs: {
          title: _vm.$t("migrations.confirm_title"),
          text: _vm.$t("migrations.confirm_text"),
        },
        on: { onConfirm: _vm.onConfirmMigration },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }